import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { UserActions } from '@next/core-lib/user';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, finalize, map, startWith, switchMap } from 'rxjs/operators';

import * as SoilTypeActions from './soil-type.actions';
import { SoilTypeState } from '../models/soil-type.models';
import { SoilTypeApiService } from '../services/soil-type-api.service';

@Injectable()
export class SoilTypeEffects {
  protected store = inject<Store<SoilTypeState>>(Store);
  protected actions$ = inject(Actions);
  private readonly api = inject(SoilTypeApiService);
  private readonly platform = inject<Object>(PLATFORM_ID);

  /**
   * userInitializedBefore is used to execute actions on the browser side during startup.
   */
  userInitializedBefore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.userInitializedBefore),
      switchMap(() =>
        this.api.getSoilTypes().pipe(
          map((soilTypes) => SoilTypeActions.setSoilTypes({ soilTypes })),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
  /**
   * userInitialized+isPlatformBrowser does the same as above, but also works for newly
   * initialized sessions when users log in on this site.
   */
  userInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.userInitialized),
      filter(() => isPlatformBrowser(this.platform)),
      switchMap(() =>
        this.api.getSoilTypes().pipe(
          map((soilTypes) => SoilTypeActions.setSoilTypes({ soilTypes })),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
}
